import Style from './panelStyles.module.scss';
import { useNode } from '@craftjs/core';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { ControlsGroup } from './uiKit/controlsGroup/controlsGroup';
import { SettingsInput } from './uiKit/input/settingsInput';
import { PanelContainer } from './uiKit/panelContainer/panelContainer';
import { FormRepeatableContainerProps } from '../../types/RepeatableContainer';

export const RepeatableContainerPanel = () => {
  const { t } = useScopedTranslation('GeneralFormBuilder.Panels.RepeatableContainer');
  const {
    actions: { setProp },
    props,
  } = useNode((node) => ({
    props: node.data.props as FormRepeatableContainerProps,
  }));

  return (
    <PanelContainer header={t('Header')} panelName={'General'}>
      <ControlsGroup header={t('AddButtonText')} contentClassName={Style.flexContainer}>
        <SettingsInput
          placeholder={t('AddButtonTextPlaceholder')}
          value={props.addButtonText}
          onChange={(e) =>
            setProp((p: FormRepeatableContainerProps) => {
              p.addButtonText = e.target.value;
            }, 500)
          }
        />
      </ControlsGroup>
    </PanelContainer>
  );
};
